import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import UnlockPDFImagesListScreen from "./UnlockPDFImagesListScreen";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import { BASE_URL } from "../Config";

function UnlockPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Unlock PDF files" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/unlock_pdf", title: "Remove PDF Password" },
    data2: { link: "/unlock_pdf", title: "PDF Unlock" },
    data3: { link: "/unlock_pdf", title: "Decrypt PDF files" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Unlock PDF files online instantly. Remove PDF passwords, disable restrictions, and access secured documents quickly with our safe PDF unlock tool."
      ></meta>
      <meta
        name="keywords"
        content="unlock pdf, remove pdf password, pdf unlock, unlock pdf online, remove password from pdf, pdf password remover, decrypt pdf, unprotect pdf, pdf security remover, unlock secured pdf, pdf restriction remover, pdf unlock tool, remove pdf protection, unlock pdf free, pdf editor online, open locked pdf, pdf password breaker,"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <UnlockPDFImagesListScreen title={title}></UnlockPDFImagesListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Unlock PDF Offline Tool is a reliable and efficient solution designed to help users remove password protection and usage restrictions from PDF files without requiring an internet connection. This powerful offline PDF unlock software enables users to easily unlock secured PDF documents, remove password from PDF, and eliminate editing, printing, and copying restrictions while regaining full access to their files with complete data privacy. Since the entire process runs locally on your device, it ensures maximum security and removes the risk of uploading sensitive documents online, making it ideal for confidential business files, legal documents, invoices, research papers, and personal records. With fast processing speed, high success rates, and support for all major operating systems, this tool can unlock PDF files quickly, even for large or complex documents. Its intuitive interface allows both beginners and professionals to remove PDF passwords in just a few clicks. Whether you are searching for an offline PDF password remover, remove password from PDF offline, unlock PDF without internet, remove PDF security offline, decrypt PDF files locally, or PDF restriction remover tool, this offline PDF unlocking solution delivers convenience, privacy, and high performance, making it a top choice for seamless and secure PDF access." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Unlock",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Unlock PDF tool"
            why_use={[
              {
                title: "Data Privacy & Security",
                description:
                  "Our offline PDF unlock tool works locally on your device, ensuring sensitive or confidential documents are not uploaded to third-party servers or exposed to data breaches.",
              },
              {
                title: "No Internet Dependency",
                description:
                  "This website allows users to unlock PDF files without internet access, making it ideal for secure environments, remote locations, or restricted networks.",
              },
              {
                title: "Remove Forgotten Passwords",
                description:
                  "Our website helps users to remove password from PDF files when the password is lost or forgotten, saving time and preventing data loss.",
              },

              {
                title: "Regain Editing & Printing Access",
                description:
                  "Easily removes restrictions on editing, copying, and printing so users can fully reuse their own PDF documents.",
              },
              {
                title: "Faster Processing",
                description:
                  "Offline PDF unlocking is usually faster since files are processed directly on the system without upload or download delays.",
              },
              {
                title: "Safe for Confidential Documents",
                description:
                  "Perfect for legal, financial, medical, academic, and business PDFs where privacy and compliance are critical.",
              },
              {
                title: "Works Anytime, Anywhere",
                description:
                  "Since it does not rely on online services, users can unlock PDF files even in offline or high-security environments.",
              },
              {
                title: "Cost-Effective Solution",
                description:
                  "Eliminates the need for paid online services or repeated subscriptions to unlock secured PDFs.",
              },
              {
                title: "User-Friendly Operation",
                description:
                  "Our offline tools offer a simple interface, allowing anyone to remove PDF passwords in just a few clicks.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app/id${1623109999}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default UnlockPDFMain;
